<app-admin-boilerplate>
    @if (event$ | async; as lrpEvent){
        <app-event-headline [event]="lrpEvent"/>
    @if (archiveData(lrpEvent.eventEnd)){
        <div class="w-full p-4 bg-amber-300 rounded-2xl">  
            This event has archived, it is no longer possible to view data about event attendees. 
        </div>
    }
    @else {
        <div class="flex gap-4">
            <div class="w-full">
                <div class="flex gap-4 justify-evenly">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <table class="table w-full">
                    <thead class="">
                        <th class="w-auto text-start px-6">Player Name</th>
                        <th>Character</th>
                        <th class="w-[150px]">Booking Type</th>
                        <th class="w-[150px]">Payment Status</th>
                    </thead>
                    <tbody>
                        @for (booking of eventBookings(lrpEvent); track $index){
                            <tr class="text-sm !py-1 curosor-pointer" [routerLink]="['/admin/events',lrpEvent.eventLink,'booking',booking.bookingID]">
                                <td class="!py-1">{{ booking.surname ?? booking.user.surname| titlecase }}, {{ booking.firstName ?? booking.user.firstname | titlecase }}</td>
                                <td class="!py-1">{{ booking.displayName  }}</td>
                                <td class="!py-1 !ps-10 ">
                                    @if (ticketLookup('Player', booking)){
                                        <fa-icon class="me-3" [icon]="['fas','ticket']" title="Player Booking"></fa-icon>
                                    }
                                    @if (ticketLookup('Crew',booking)){
                                        <fa-icon class="me-3" [icon]="['fas','spaghetti-monster-flying']" title="Crew Booking"></fa-icon>
                                    }
                                    @if (ticketLookup('Staff',booking)){
                                        <fa-icon class="me-3" [icon]="['fas','stopwatch']" title="Staff Booking"></fa-icon>
                                    }
                                    @if (ticketLookup('Meal',booking)){
                                        <fa-icon class="me-3" [icon]="['fas','utensils']" title="Meal Ticket"></fa-icon>
                                    }
                                    @if (ticketLookup('Bunk', booking)){
                                        <fa-icon class="me-3" [icon]="['fas','bed']" title="Bunk Requested"></fa-icon>
                                    }
                                </td>
                                <td class="!py-1 text-lg text-center flex gap-3 ms-10">
                                    @if (booking.paid){
                                        <fa-icon class="text-green-500" [icon]="['fas','circle-check']" [title]="(booking.bookingPaid | date:'dd-MM-yyyy HH:mm')!"/>
                                    }
                                    @else if (booking.payOnGate){
                                        <fa-icon [icon]="['fas','door-open']" title="Pay on gate"/>
                                    }
                                    @else {
                                        @if (booking.totalPaid > 0){
                                            <fa-icon class="text-amber-500" [icon]="['fas','circle-question']" [title]="(booking.totalDue - booking.totalPaid | currency:'GBP') + ' Due'" />
                                        }
                                        @else {
                                            <fa-icon class="text-red-500" [icon]="['fas','circle-xmark']" />
                                        }
                                    }
                                    @if (booking.paypalPaymentId){
                                        <fa-icon class="text-blue-500" [icon]="['fab','paypal']" [title]="'Paypal ID: ' + booking.paypalPaymentId"/>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    }
}
</app-admin-boilerplate>
